"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BASE_CONCEPT_FRAGMENT = void 0;
var _fetching = require("@ori/fetching");
var _labels = require("./labels");
const BASE_CONCEPT_FRAGMENT = exports.BASE_CONCEPT_FRAGMENT = (0, _fetching.gql)`
  ${_labels.PRODUCT_LABELS_FRAGMENT}
  fragment BaseConcept on Concept {
    brand {
      name
    }
    categories {
      name
    }
    conceptCode
    labels {
      ...ProductLabels
    }
    name
    ratingAverage
    ratingCount
  }
`;
